import {WorkforceProfileCompetencyRow} from '../../types/WorkforceProfileTypes';

export const getAlignmentRowKey = (row: WorkforceProfileCompetencyRow): string =>
  `${row.nameEn ?? ''}|${row.nameDe ?? ''}|${row.name}`;
